import {Injectable} from 'ng-metadata/core';

@Injectable()
export class SearchResultAddToFavoritesMenuService {
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResult/searchResultAddToFavoritesMenu/searchResultAddToFavoritesMenu.service.ts